import { render, staticRenderFns } from "./SupplierDeleteCategoryModal.vue?vue&type=template&id=2cf8a89e&scoped=true"
import script from "./SupplierDeleteCategoryModal.vue?vue&type=script&lang=js"
export * from "./SupplierDeleteCategoryModal.vue?vue&type=script&lang=js"
import style0 from "./SupplierDeleteCategoryModal.vue?vue&type=style&index=0&id=2cf8a89e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf8a89e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cf8a89e')) {
      api.createRecord('2cf8a89e', component.options)
    } else {
      api.reload('2cf8a89e', component.options)
    }
    module.hot.accept("./SupplierDeleteCategoryModal.vue?vue&type=template&id=2cf8a89e&scoped=true", function () {
      api.rerender('2cf8a89e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/supplier/components/SupplierDeleteCategoryModal.vue"
export default component.exports